<template>
  <vue-plyr
    ref="plyr"
    :options="{ clickToPlay: !disableClickOnPlay, controls: videoControls, iconUrl: '/vendor/plyr/sprite/plyr.svg', autoplay: autoplay, loop: {active: loop} }"
  >
    <video
      :id="videoId || `ok-video-element`"
      :class="className"
      :src="src"
      :autoplay="autoplay"
      controls
      type="video/mp4"
      :data-poster="poster"
    />
  </vue-plyr>
</template>

<script>
import VuePlyr from 'vue-plyr'

export default {
  name: 'OkVideoPlayer',
  components: {
    VuePlyr,
  },
  props: {
    videoId: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    disableClickOnPlay: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    videoControls() {
      return this.compact ? ['play', 'volume'] : ['play', 'progress', 'current-time', 'volume', 'fullscreen']
    },
  },
  mounted() {
    this.$refs.plyr.player.on('loadeddata', this.emitDataLoaded)
    this.$refs.plyr.player.on('loadedmetadata', this.emitDataLoaded)
  },
  beforeDestroy() {
    this.$refs.plyr.player.off('loadeddata', this.emitDataLoaded)
    this.$refs.plyr.player.off('loadedmetadata', this.emitDataLoaded)
  },
  methods: {
    emitDataLoaded() {
      this.$emit('data-loaded')
    },
  },
}
</script>

<style lang="scss">
@import "~@/assets/vendor/plyr/plyr.css";

</style>
